import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { Select } from "..";
import { useTranslation } from "react-i18next";
import { useGroups } from "../../../hooks/apiHooks/groups";

const GroupsFilter = ({
  fieldName,
  autoWidth,
  getValue,
  sort,
  filters,
  fields,
  includes
}) => {
  const { t } = useTranslation();
  const { getGroups, isLoading } = useGroups();
  const [groups, setGroups] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    setMenuItems([
      {
        value: "",
        label: t("filterLabels.showAll")
      },
      ...groups.map(group => ({
        value: getValue(group),
        label: group.name
      }))
    ]);
  }, [groups]);

  useEffect(() => {
    getGroups({
      filters,
      sort,
      fields,
      includes
    }).then(response => setGroups(response.data));
  }, [JSON.stringify({ sort, filters, fields, includes })]);

  return (
    <Select
      autoWidth={autoWidth}
      disableUnderline
      name={fieldName}
      menuItems={menuItems}
      label={t("filterLabels.group")}
      loading={isLoading}
    />
  );
};

export default GroupsFilter;

GroupsFilter.propTypes = {
  fieldName: PropTypes.string,
  autoWidth: PropTypes.bool,
  getValue: PropTypes.func,
  sort: PropTypes.array,
  filters: PropTypes.object,
  fields: PropTypes.object,
  includes: PropTypes.array
};

GroupsFilter.defaultProps = {
  fieldName: "group",
  autoWidth: false,
  getValue: ({ id }) => id,
  sort: ["name"],
  filters: { active: true },
  fields: { group: ["name", "positions", "locations"] },
  includes: []
};
